define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/heading/Boolean",
	"csi/xml"
], function(array,declare,BooleanRen,xml) {

	return declare(BooleanRen, {
		canComment: function(/*Context*/ctx, /*Heading*/h) {
			// summary: disable commenting
			return false;
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: disable filtering
			return null;
		},

		_getRenderAction: function(/*Context*/ctx, /*Heading*/h) {
			// summary: disable checkbox if no value selected
			return xml.isValidURL(ctx.view.get("dependsOnValue")) ? this.inherited(arguments) : null;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: determine if switchboard value is already in EnumValue.DependsOn
			var value = ctx.view.get("dependsOnValue");
			return xml.isValidURL(value) && (array.indexOf(ctx.getNode().DependsOn, value) >= 0);
		}
	});
});